import React, { useEffect, useState } from "react";
import styles from "../../assets/scss/WebHeader.module.scss";
import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from '../../assets/images/cropLogo.png';
import Lng from "../../Lng/Lng";

const WebHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const [activeSection, setActiveSection] = useState("features");

    const sections = ["features", "Freemium" ,"download", "contact"];

 const scrollToSection = (id) => {
    setMenuOpen(false);
    setActiveSection(id); // ⭐ IMPORTANT

    const element = document.getElementById(id);
    if (element) {
        const headerOffset = 100;
        const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }
};





useEffect(() => {
    const handleScroll = () => {
        let current = activeSection;

        sections.forEach((section) => {
            const elem = document.getElementById(section);
            if (elem) {
                const top = elem.getBoundingClientRect().top;
                if (top <= 120) {
                    current = section;
                }
            }
        });

        setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
}, [sections]);



    return (
        <header className={styles.header}>
            <div className={styles.container}>
                {/* Left Logo Section */}
                <div className={styles.logoSection}>
                    <img
                        src={Logo}
                        alt="logo"
                        className={styles.logo}


                    />

                </div>

                {/* Center Nav Links */}
                <nav className={`${styles.nav} ${menuOpen ? styles.active : ""}`}>
                    {sections.map((section) => (
                        <button
                            key={section}
                            onClick={() => scrollToSection(section)}
                            className={activeSection === section ? styles.activeLink : ""}
                        >
                            {section.charAt(0).toUpperCase() + section.slice(1)}
                        </button>
                    ))}
                    <button
                        onClick={() => {
                            setMenuOpen(false);
                            navigate("/login");
                        }}
                        className={styles.loginBtnshow}>Login
                    </button>
                </nav>



                {/* Right Buttons */}
                <div className={styles.actions}>
                    <button
                        onClick={() => {
                            setMenuOpen(false);
                            navigate("/login");
                        }}
                        className={styles.loginBtn}>Login
                    </button>



                    <button
                        className={styles.signupBtn}
                        onClick={() => {
                            setMenuOpen(false);
                            scrollToSection("contact");
                        }}
                    >
                        Let’s talk
                    </button>

                    <div className={styles.lngFixed} >
                        {/* <label className={styles.lngLabel}>Language</label> */}
                        <Lng />
                    </div>




                </div>

                {/* Mobile Menu Toggle */}
                <div className={styles.menuToggle} onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
                </div>
            </div>
        </header>
    );
};

export default WebHeader;
